import { useEffect, useState } from "react";

type Props = {
  value: number;
  onChange: (val: number) => void;
  style?: React.CSSProperties;
  disabled?: boolean;
  min?: number;
};

/**
 * Texteingabe für Eurobeträge: erlaubt Komma als Dezimaltrennzeichen,
 * normalisiert beim Verlassen auf 2 Nachkommastellen.
 */
export function EurInput({ value, onChange, style, disabled, min = 0 }: Props) {
  const [text, setText] = useState(() => value.toFixed(2).replace(".", ","));

  useEffect(() => {
    setText(value.toFixed(2).replace(".", ","));
  }, [value]);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const raw = e.target.value;
    // Nur Ziffern, Komma und Punkt erlauben
    if (/^[\d]*[,.]?[\d]*$/.test(raw)) {
      setText(raw);
    }
  }

  function handleBlur() {
    const numeric = parseFloat(text.replace(",", ".")) || 0;
    const clamped = min !== undefined ? Math.max(min, numeric) : numeric;
    const rounded = Math.round(clamped * 100) / 100;
    setText(rounded.toFixed(2).replace(".", ","));
    onChange(rounded);
  }

  return (
    <input
      type="text"
      inputMode="decimal"
      value={text}
      disabled={disabled}
      onChange={handleChange}
      onBlur={handleBlur}
      style={{ textAlign: "right", ...style }}
    />
  );
}
